import api from "./ApiClient";

const BASE_PATH_PRODUCTS = '/foodz/api/v1/estoque';

class ProductService {
  static async registerProduct(product) {
    const response = await api.post(
      `${BASE_PATH_PRODUCTS}`,
      product
    );
    return response.data;
  }

  static async getAllProducts(params = {}) {
    const clientCode = sessionStorage.getItem('clientCode');
    // sort pode ser string "field,dir" ou array ["field,dir","field2,dir2"]
    const sortValue = Array.isArray(params.sort)
      ? (params.sort.length ? params.sort : undefined)
      : (params.sort?.trim() || undefined);

    const requestParams = {
      clientCode,
      page: params.page || 0,
      size: params.size || params.pageSize || 10,
      ...(sortValue !== undefined && { sort: sortValue }),
    };

    if (params.search) requestParams.search = params.search;

    if (params.active !== undefined) requestParams.active = params.active;
    if (params.minPrice !== undefined) requestParams.minPrice = params.minPrice;
    if (params.maxPrice !== undefined) requestParams.maxPrice = params.maxPrice;

    if (params.categories && Array.isArray(params.categories)) {
      requestParams.categories = params.categories;
    }

    const response = await api.get(`${BASE_PATH_PRODUCTS}/listarTodos`, {
      params: requestParams
    });

    return response.data;
  }

  static async getActiveProducts({ search = '', currentPage, pageSize, sort }) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = {
      clientCode,
      search,
      page: currentPage,
      size: pageSize,
      ...(sort?.trim() && { sort: sort.trim() })
    };
    const response = await api.get(
      `${BASE_PATH_PRODUCTS}/listarProdutosAtivosNoCardapio`,
      { params }
    );
    return response.data;
  }

  static async findSpecificProduct(productId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput: productId };
    const response = await api.get(
      `${BASE_PATH_PRODUCTS}/pesquisarProduto`,
      { params }
    );
    return response.data;
  }

  static async getProductsByInput(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, searchInput };
    const response = await api.get(
      `${BASE_PATH_PRODUCTS}/pesquisarProdutos`,
      { params }
    );
    return response.data;
  }

  static async updateProduct(productId, product) {
    const response = await api.put(
      `${BASE_PATH_PRODUCTS}/atualizar`,
      product,
      { params: { productId } }
    );
    return response.data;
  }

  static async updateProductQuantity(searchInput, action, product) {
    const params = { searchInput, action };
    const response = await api.put(
      `${BASE_PATH_PRODUCTS}/atualizarQuantidadeProdutos`,
      product,
      { params }
    );
    return response.data;
  }

  // Ajuste manual de estoque (botão "Atualizar Estoque") — motivo obrigatório.
  // Endpoint novo e dedicado, não reaproveita /atualizarQuantidadeProdutos
  // (esse continua intocado, usado ao vivo pelo checkout).
  static async applyManualStockAdjustment({ searchInput, action, quantity, reasonCode, reasonText }) {
    const clientCode = sessionStorage.getItem('clientCode');
    const payload = {
      clientCode,
      searchInput,
      action,
      quantity,
      reasonCode,
      reasonText: reasonText || null
    };
    const response = await api.put(
      `${BASE_PATH_PRODUCTS}/ajusteManual`,
      payload
    );
    return response.data;
  }

  static async deleteProduct(productId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const params = { clientCode, productId };
    const response = await api.delete(
      `${BASE_PATH_PRODUCTS}/remover`,
      { params }
    );
    return response.data;
  }


  static async updateBatchStatus(payload) {
    const clientCode = sessionStorage.getItem("clientCode");
    const response = await api.put(
      `${BASE_PATH_PRODUCTS}/atualizarStatusEmMassa`,
      payload,
      { params: { clientCode } }
    );
    return response.data;
  }
}

export default ProductService;